import { Guid } from 'guid-typescript';
import { LocalStorageService } from './localStorageService';

const generateDeviceId = (): string => {
  return Guid.create().toString();
};

export class DeviceService {
  static getDeviceId(): string {
    const deviceId = LocalStorageService.getDeviceId();
    if (deviceId) {
      return deviceId;
    }

    const newDeviceId = generateDeviceId();
    LocalStorageService.setDeviceId(newDeviceId);
    return newDeviceId;
  }
}
